
app.sliderController = app.sliderController || {};
app.sliderController.defaultAction = {
   
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {

        var self = this;
        this.initSlider();

        $(window).resize(function() {
            self.initSlider();
        });
    },

    initSlider : function () {
        if ($('.actu-slider').length > 0) {
        $(".actu-slider").slick({
            autoplay: true,
            autoplaySpeed: 3000,
            arrows: false,
            fade: true
        });

        $(".actu-navigation .actu-prev").on("click", function () {
            $('.actu-slider').slick('slickPrev');
        });

        $(".actu-navigation .actu-next").on("click", function () {
            $('.actu-slider').slick('slickNext');
        });
    }
    }
        
};

$(document).ready(function(){
    app.sliderController.defaultAction.init();
});
